// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image .lazyload[data-v-025bb0d5],.image .lazyloading[data-v-025bb0d5]{opacity:0}.image .lazyloaded[data-v-025bb0d5]{opacity:1;transition:opacity 100ms}.image img[data-v-025bb0d5]{width:100%}\n", ""]);
// Exports
module.exports = exports;
